import { toast as sonnerToast, type ExternalToast } from 'sonner'

export default function toast(message: string, options?: ExternalToast) {
  sonnerToast(message, withDefaults(options))
}

function withDefaults(options?: ExternalToast): ExternalToast {
  return {
    position: 'bottom-right',
    closeButton: true,
    ...options,
  }
}

export function error(message: string, options?: ExternalToast) {
  sonnerToast.error(message, withDefaults(options))
}

export function success(message: string, options?: ExternalToast) {
  sonnerToast.success(message, withDefaults(options))
}

export function warning(message: string, options?: ExternalToast) {
  sonnerToast.warning(message, withDefaults(options))
}

export function info(message: string, options?: ExternalToast) {
  sonnerToast.info(message, withDefaults(options))
}
